/**
 * Keyboard focus detection utility
 * Tracks whether the user is navigating with keyboard or mouse
 * and adds/removes a class on the document element accordingly
 */

export function initKeyboardFocusDetection() {
  let isKeyboardUser = false;

  if (typeof window === 'undefined' || typeof document === 'undefined') {
    return;
  }

  // Detect keyboard usage (Tab and Arrow keys)
  function handleKeyDown(e: KeyboardEvent) {
    if ((e.key === 'Tab' || e.key.startsWith('Arrow')) && !isKeyboardUser) {
      isKeyboardUser = true;
      document.documentElement.classList.add('has-keyboard-focus');
    }
  }

  // Detect mouse usage
  function handleMouseDown() {
    if (isKeyboardUser) {
      isKeyboardUser = false;
      document.documentElement.classList.remove('has-keyboard-focus');
    }
  }

  // Detect pointer/touch usage
  function handlePointerDown(e: PointerEvent) {
    // Only track mouse and pen pointers, not touch
    if ((e.pointerType === 'mouse' || e.pointerType === 'pen') && isKeyboardUser) {
      isKeyboardUser = false;
      document.documentElement.classList.remove('has-keyboard-focus');
    }
  }

  document.addEventListener('keydown', handleKeyDown, true);
  document.addEventListener('mousedown', handleMouseDown, true);
  document.addEventListener('pointerdown', handlePointerDown, true);
}
